module.exports = __webpack_public_path__ + "static/media/spend-nohidden-1-mobile.200f622b.jpg";